import React, { useState, useEffect, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import PasswordSetModal from "../../../../components/modals/PasswordSetModal";
import UnavailableModal from "../../../../components/modals/UnavailableModal";
import privateAxios from "../../../../utils/axiosPrivate";
import { FaInfoCircle, FaSyncAlt, FaMinusCircle, FaLink } from "react-icons/fa";
import { showAlert, showToast } from "../../../../utils/utils";
import { Link, useParams } from "react-router-dom";
import { PiPlugsFill, PiPlugsConnectedFill } from "react-icons/pi";
import { showToastType } from "../../../../utils/constants/appConstants";
import {
  getUserBankAccountUpdateData,
  getUserDirectDebitData,
  getUserGoCardlessBankData
} from "../../../../redux/userManagementSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  accSofywareName,
  alertActions,
  commonErrMsg,
  createPricingPlan,
  createReffPartner,
  customerTab,
  profiletexts,
  tooltips
} from "../../../../locales/en";
import {
  COMPLETE,
  COUNTRY_CODE_AU,
  COUNTRY_CODE_NZ,
  GOCARDLESS,
  PARTIAL,
  UNMATCHED
} from "../../../../utils/constants/appConstants";
import styles from "./../../../../assets/scss/custom.module.scss";
import "./directdebit.scss";
import {
  getDirectDebitUrl,
  getGocardLessMandateStatusUrl,
  getGocardLessMandatesUrl,
  getOnboardBankAccURL,
  getPasswordConfirmationURL,
  getUserAccountingBankAccUrl
} from "../../../../utils/constants/apiEndPoints";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { getActiveStatusOptions } from "../../../../utils/getDropdownOptions";

const DirectDebit = ({ accSoftwareIsConnctData, bankName, accSoftwareId }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const isFocused = useRef(null);
  const isBankFocused = useRef(null);

  const [correctPassword, setCorrectPassword] = useState(false);
  const [addPasswordModal, setAddPasswordModal] = useState(false);
  const [directDebitModal, setDirectDebitModal] = useState(false);
  const [modalData, setModalData] = useState("");
  const [status, setStatus] = useState(false);
  const [directDebitStatus, setDirectDebitStatus] = useState("");
  const [directDebitMandateStatus, setDirectDebitMandateStatus] = useState("");
  const [bankAccount, setBankAccount] = useState("");
  const [bankAccountLink, setBankAccountLink] = useState("false");
  const [mandateId, setMandateId] = useState("");
  const [isMandateIdGet, setIsMandateIdGet] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [updateBankAccount, setUpdateBankAccount] = useState("");
  const [bankError, setBankError] = useState("");

  const tooltipsArray = [
    { id: "tooltip-gocardless-status" },
    { id: "tooltip-mandateRemove" }
  ];

  const { usersData } = useSelector((state) => state.userManagement);
  const country = usersData?.userAccountMeta?.primaryCountry;

  const handleModalClose = () => {
    setCorrectPassword(false);
    setAddPasswordModal(false);
  };

  const handleDirectDebitModal = () => {
    setDirectDebitModal(!directDebitModal);
  };

  // for accounntngSoft bank account data
  const [accountingBankData, setAccountingBankData] = useState();
  const handleGetAccSoftwareBankData = useCallback(async () => {
    try {
      const response = await privateAxios.get(
        getUserAccountingBankAccUrl(accSoftwareId, id)
      );
      const responseData = response?.data?.data;
      setAccountingBankData(responseData);
    } catch {
      //handle error
    }
  }, [id, accSoftwareId]);

  // ----------------- GoCardless Bank Data -----------------
  const [goCardlessBankData, setGoCardlessBankData] = useState("");
  const goCardlessCalledRef = useRef(false);
  useEffect(() => {
    if (goCardlessCalledRef.current) return;
    goCardlessCalledRef.current = true;
    const handleGetGoCardlessBankData = async () => {
      try {
        const paramsData = { userAccountId: id };
        const response = await dispatch(
          getUserGoCardlessBankData(paramsData)
        ).unwrap();
        const responseData = response?.data;
        setGoCardlessBankData(responseData);
      } catch {
        // handle catch here;
      }
    };
    handleGetGoCardlessBankData();
  }, [id]);

  // ----------------- Direct Debit Status -----------------
  const directDebitCalledRef = useRef(false);
  const handleDirectDebitStatus = async () => {
    try {
      const paramsData = { userAccountId: id };
      const response = await dispatch(
        getUserDirectDebitData(paramsData)
      ).unwrap();
      const responseData = response.data;
      setIsMandateIdGet(responseData?.mandate?.id);
      setMandateId(responseData?.mandate?.id);
      setDirectDebitStatus(responseData);
      setDirectDebitMandateStatus(responseData?.mandate?.status);
      setStatus(responseData?.directDebit?.status);
      setBankAccount(responseData?.bankAccount?.accountNumber);
      setBankAccountLink(responseData?.bankAccount?.accountLinked);
    } catch {
      // handle catch here;
    }
  };
  useEffect(() => {
    if (directDebitCalledRef.current) return;
    directDebitCalledRef.current = true;
    handleDirectDebitStatus();
  }, [id]);

  const handleGocardlessStatusUpdate = async () => {
    if (!mandateId) {
      showToast(
        "Mandate ID is required to update GoCardless status.",
        showToastType.error
      );
      return;
    }
    try {
      const response = await privateAxios.put(
        getGocardLessMandateStatusUrl(mandateId),
        {},
        { params: { userAccountId: id } }
      );
      setModalData(response.data.data);
      const responseData = response.data.data;
      if (response.status === 200 || response.status === 201) {
        setDirectDebitModal(true);
        setStatus(true);
        setDirectDebitMandateStatus(responseData?.mandate?.status);
      }
    } catch {
      setDirectDebitModal(true);
    }
  };

  // Handle dropdown value change
  const handleStatusChange = async (e) => {
    const updatedStatus = e.target.value === "true";
    setStatus(updatedStatus);
    await handleDirectDebitStatusUpdate(updatedStatus);
  };

  // Handle API call for status update
  const handleDirectDebitStatusUpdate = async (updatedStatus) => {
    try {
      const response = await privateAxios.patch(
        getDirectDebitUrl,
        {},
        {
          params: {
            status: updatedStatus,
            userAccountId: id
          }
        }
      );
      showToast(response.data.message, showToastType.success);
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.join(", ") ||
        error.response?.data?.message ||
        error.message ||
        commonErrMsg?.item4;
      showToast(errorMessage, showToastType.error);
    }
  };

  const [isMandateEditable, setIsMandateEditable] = useState(false);
  const [mandateIdDraft, setMandateIdDraft] = useState(mandateId);

  const [isBankEditable, setIsBankEditable] = useState(false);

  const [editSource, setEditSource] = useState("");

  const handlePasswordEntered = async (password) => {
    try {
      const response = await privateAxios.post(getPasswordConfirmationURL, {
        password,
        method: "PUT",
        endpoint: getOnboardBankAccURL
      });
      if (response.status === 200) {
        setCorrectPassword(true);
        setAddPasswordModal(false);

        if (editSource === "mandate") {
          setIsMandateEditable(true);
          setTimeout(() => {
            isFocused?.current?.focus();
          }, 0);
        }

        if (editSource === "removemandate") {
          handleRemoveMandate();
        }

        if (editSource === "bank") {
          setIsBankEditable(true);
          setTimeout(() => {
            isBankFocused?.current?.focus();
          }, 0);
        }

        if (editSource === "relinkAccount") {
          setShowRelinkAccount(true);
        }

        setEditSource("");
      }
    } catch (error) {
      showToast(
        error.response?.data?.message || commonErrMsg?.item8,
        showToastType.error
      );
    }
  };

  const handleMandateRemove = async (e) => {
    if (!isMandateEditable) {
      e.preventDefault();
      const result = await showAlert(
        customerTab?.directDebit.errMsg.item1,
        customerTab?.directDebit.errMsg.item2,
        alertActions.warning,
        alertActions.Confirm,
        alertActions.Cancel
      );

      if (result.isConfirmed) {
        setEditSource("removemandate");
        setAddPasswordModal(true);
      }
    }
  };

  const handleRemoveMandate = async () => {
    if (!mandateId) {
      showToast(commonErrMsg?.item19, showToastType.error);
      return;
    }
    try {
      const response = await privateAxios.patch(
        getGocardLessMandatesUrl(mandateId),
        {},
        {
          params: {
            userAccountId: Number(id)
          }
        }
      );
      if (response.status === 200 || response.status === 201) {
        setMandateIdDraft("");
        handleDirectDebitStatus();
        setIsMandateEditable(false);
        showToast(response.data.message, showToastType.success);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || commonErrMsg.item4;
      showToast(errorMessage, showToastType.error);
    }
  };

  const handleMandateClick = async (e) => {
    if (!isMandateEditable) {
      e.preventDefault();
      const result = await showAlert(
        customerTab?.directDebit.errMsg.item3,
        customerTab?.directDebit.errMsg.item4,
        alertActions.warning,
        alertActions.Confirm,
        alertActions.Cancel
      );

      if (result.isConfirmed) {
        setEditSource("mandate");
        setAddPasswordModal(true);
      }
    }
  };

  const handleBankClick = async (e) => {
    if (!isBankEditable) {
      e.preventDefault();
      const result = await showAlert(
        customerTab?.directDebit.errMsg.item5,
        customerTab?.directDebit.errMsg.item6,
        alertActions.warning,
        alertActions.Confirm,
        alertActions.Cancel
      );

      if (result.isConfirmed) {
        setEditSource("bank");
        setAddPasswordModal(true);
      }
    }
  };

  const handleMandateBlur = () => {
    if (correctPassword && mandateIdDraft !== mandateId) {
      setMandateId(mandateIdDraft);
      handleUpdateMandate(mandateIdDraft);
    }
  };

  const handleBankBlur = () => {
    if (correctPassword) {
      setIsBankEditable(false);
    }
  };

  const handleUpdateMandate = async (updatedMandateId) => {
    if (!updatedMandateId) {
      showToast(commonErrMsg?.item20, showToastType.error);
      return;
    }
    try {
      const response = await privateAxios.put(
        getGocardLessMandatesUrl(updatedMandateId),
        {},
        {
          params: {
            userAccountId: Number(id)
          }
        }
      );
      if (response.status === 200 || response.status === 201) {
        setMandateId(response?.data?.data?.mandate?.id);
        setStatus(response?.data?.data?.directDebit?.status);
        showToast(
          response?.data?.data?.message || response?.data?.message,
          showToastType.success
        );
        handleDirectDebitStatus();
        reloadUserBankData(false, false);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || commonErrMsg.item4;
      if (error.response.status === 500) {
        setMandateIdDraft("");
        setIsMandateIdGet("");
        setMandateId("");
        handleDirectDebitStatus();
      }
      showToast(errorMessage, showToastType.error);
    } finally {
      setIsMandateEditable(false);
    }
  };

  const [showRelinkAccount, setShowRelinkAccount] = useState(false);

  // `bankName` holds whatever the connected accounting software returned: a list
  // of accounts, a single account object, or an empty object when the fetch
  // didn't land. Normalise to a list so callers can map/find over it safely.
  const toAccountList = (value) => {
    if (Array.isArray(value)) return value;
    return value && typeof value === "object" ? [value] : [];
  };

  const getConnectedBankAccounts = () => {
    switch (accSoftwareIsConnctData?.accountingSoftwareType) {
      case "MYOB":
        return toAccountList(bankName?.bankAccount);
      case "QuickBooks":
        return Array.isArray(bankName)
          ? bankName
          : toAccountList(bankName?.bankAccount);
      default:
        return toAccountList(bankName);
    }
  };

  const buildRelinkBankOptions = () => {
    const accounts = getConnectedBankAccounts();

    switch (accSoftwareIsConnctData?.accountingSoftwareType) {
      case "Reckon":
        return accounts.map((account) => ({
          value: account.BankAccountID,
          label: account.Description
        }));
      case "MYOB":
        return accounts.map((account) => ({
          value: account.accountUUID,
          label: `${account.accountName} - ${account.accountNumber}`
        }));
      case "Xero":
        return accounts
          .filter((account) => account.BankAccountNumber)
          .map((account) => ({
            value: account.AccountID,
            label: `${account.Name} - ${account.BankAccountNumber}`
          }));
      case "QuickBooks":
        return accounts.map((account) => ({
          value: account.accountUUID,
          label: account.accountName
        }));
      default:
        return [];
    }
  };

  const relinkBankOptions = buildRelinkBankOptions().filter(
    (option) => option.value
  );

  const handleReLinkAccount = async (e) => {
    e.preventDefault();
    const result = await showAlert(
      customerTab?.directDebit.errMsg.item7,
      customerTab?.directDebit.errMsg.item8,
      alertActions.warning,
      alertActions.Confirm,
      alertActions.Cancel
    );

    if (result.isConfirmed) {
      setEditSource("relinkAccount");
      setAddPasswordModal(true);
    }
  };

  const handleBankDataChange = (e) => {
    setUpdateBankAccount(e.target.value);
    setBankError("");
  };

  const [lastManualBankAccount, setLastManualBankAccount] = useState("");

  const handleBankAccountUpdate = async (selectedValue = selectedAccount) => {
    const payload = {
      accountCode: "",
      accountUuid: null
    };

    // If manually add bank account
    if (selectedValue === "manually-add-bank-account") {
      if (country === COUNTRY_CODE_AU) {
        // Australian bank account number validation
        if (updateBankAccount.length < 7 || updateBankAccount.length > 15) {
          setBankError(customerTab?.directDebit?.auBankError);
          return;
        }
      } else if (country === COUNTRY_CODE_NZ) {
        // New Zealand bank account number validation
        if (updateBankAccount.length < 14 || updateBankAccount.length > 16) {
          setBankError(customerTab?.directDebit?.nzBankError);
          return;
        }
      }
      payload.accountCode = updateBankAccount;
      payload.accountUuid = null;
    } else if (accSoftwareIsConnctData?.accountingSoftwareType === "Xero") {
      const selected = getConnectedBankAccounts().find(
        (item) => item.AccountID === selectedValue
      );
      if (selected) {
        // Xero may format the account number with spaces or dashes (e.g. NZ's
        // "01-0123-0123456-00"), which breaks payment. Strip them here while
        // keeping accountUuid intact so writebacks keep working.
        payload.accountCode = selected.BankAccountNumber?.replace(/[\s-]/g, "");
        payload.accountUuid = selected.AccountID;
      }
    } else if (
      accSoftwareIsConnctData?.accountingSoftwareType === "MYOB" ||
      accSoftwareIsConnctData?.accountingSoftwareType === "QuickBooks"
    ) {
      const selected = getConnectedBankAccounts().find(
        (item) => item.accountUUID === selectedValue
      );
      if (selected) {
        // Only strip spaces/dashes when it's actually the account number -
        // the accountName fallback is a free-text label, not a number.
        payload.accountCode = selected.accountNumber
          ? selected.accountNumber.replace(/[\s-]/g, "")
          : selected.accountName;
        payload.accountUuid = selected.accountUUID;
      }
    } else if (accSoftwareIsConnctData?.accountingSoftwareType === "Reckon") {
      const selected = getConnectedBankAccounts().find(
        (item) => item.BankAccountID === selectedValue
      );
      if (selected) {
        payload.accountCode = selected.Description;
        payload.accountUuid = selected.BankAccountID;
      }
    }

    try {
      const response = await dispatch(
        getUserBankAccountUpdateData({ id, payload })
      ).unwrap();
      if (response.status === 200) {
        handleDirectDebitStatus();
        reloadUserBankData(false, false);
      }
      setBankError("");
    } catch {
      // for error handaling
    }
  };

  const handleblurBankDataChange = () => {
    handleBankAccountUpdate("manually-add-bank-account");
    setLastManualBankAccount(updateBankAccount);
  };

  const handleSelectChange = (e) => {
    const selected = e.target.value;
    setSelectedAccount(selected);
    if (selected === "manually-add-bank-account") {
      setUpdateBankAccount(lastManualBankAccount);
    } else {
      handleBankAccountUpdate(selected);
    }
  };

  const [spinning, setSpinning] = useState(false);

  const reloadUserBankData = async (showAlertFlag, setValue) => {
    setSpinning(true);

    try {
      if (!showAlertFlag) {
        await handleGetAccSoftwareBankData(setValue);
        dispatch(getUserGoCardlessBankData({ userAccountId: id }));
      } else {
        const reloadConfirm = await showAlert(
          ``,
          customerTab?.directDebit?.refreshAlert,
          alertActions?.warning,
          alertActions?.Confirm,
          alertActions?.Cancel
        );

        if (reloadConfirm.isConfirmed) {
          await new Promise((resolve) => setTimeout(resolve, 2000));
          await handleGetAccSoftwareBankData();
          dispatch(getUserGoCardlessBankData({ userAccountId: id }));
        }
      }
    } finally {
      setSpinning(false);
    }
  };

  useEffect(() => {
    if (accSoftwareId) {
      handleGetAccSoftwareBankData();
    }
  }, [handleGetAccSoftwareBankData, accSoftwareId]);

  return (
    <>
      <div className={styles.titleArea}>
        <h5>{customerTab?.directDebit.title}</h5>
      </div>
      <div className="row">
        <div className="col-12 col-sm-6 col-md-4">
          <div className="blog-input-wrap mb-3">
            <div className={`${styles.labelTitle}`}>
              <h5>{customerTab?.directDebit.directDebit}</h5>
            </div>
            <div
              className={`${styles.inputWithButton} d-flex align-items-center`}
            >
              <select
                className={`${styles.selectdropdown} withoutselecticon`}
                value={status ? "true" : "false"}
                onChange={handleStatusChange}
              >
                {getActiveStatusOptions().map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              <span className={`${styles.btnPrimary} refresh-icon added-icon`}>
                <input
                  type="button"
                  onClick={handleGocardlessStatusUpdate}
                  data-tooltip-id="tooltip-gocardless-status"
                  data-tooltip-content={tooltips.gocardlessTooltip}
                />
              </span>
            </div>
          </div>
          <div className="blog-input-wrap mb-3">
            <div className={`${styles.labelTitle}`}>
              <h5>{customerTab?.directDebit.mandateId}</h5>
            </div>
            <div
              className={`${styles.inputWithButton} d-flex align-items-center`}
            >
              <input
                type="text"
                className={styles.textfield}
                value={isMandateEditable ? mandateIdDraft : mandateId}
                onChange={(e) => setMandateIdDraft(e.target.value)}
                onMouseDown={handleMandateClick}
                onBlur={handleMandateBlur}
                ref={isFocused}
                readOnly={!isMandateEditable}
                disabled={!!mandateId}
              />

              <button
                className={`${styles.btnPrimary} ${styles.btnPrimaryHoverRed} right-icon`}
                onClick={handleMandateRemove}
                data-tooltip-id="tooltip-mandateRemove"
                data-tooltip-content={tooltips.mandateRemove}
              >
                <FaMinusCircle />
              </button>
            </div>
          </div>
          {isMandateIdGet && (
            <>
              <div className="blog-input-wrap mb-3">
                <div className={`${styles.labelTitle}`}>
                  <h5>{customerTab?.directDebit.mandateStatus}</h5>
                </div>
                <div
                  className={`${styles.inputWithButton} d-flex align-items-center`}
                >
                  <div className="inputtextfield">
                    <input
                      type="text"
                      className={`${styles.textfield}`}
                      value={directDebitMandateStatus}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="blog-input-wrap mb-3">
                <div className={`${styles.labelTitle}`}>
                  <h5>{customerTab?.directDebit.links}</h5>
                </div>
                <div
                  className={`${styles.inputWithButton} d-flex align-items-center`}
                >
                  <div className="inputtextfield">
                    <ul
                      className={`${styles.bankAccountsAlert} ${styles.customerAccountsLink}`}
                    >
                      <li className="text-info">
                        <Link
                          to={directDebitStatus?.links?.customer}
                          target="_blank"
                        >
                          <FaLink /> {profiletexts?.customer}
                        </Link>
                      </li>
                      <li className="text-info">
                        <Link
                          to={directDebitStatus?.links?.mandate}
                          target="_blank"
                        >
                          <FaLink /> {customerTab?.directDebit.mandate}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="col-12 col-sm-6 col-md-8 mb-3">
          <div className="blog-input-wrap mb-3">
            <div className={`${styles.labelTitle}`}>
              <h5>{createReffPartner?.bankAcc}</h5>
            </div>
            <div className="inputtextfield">
              <input
                type="text"
                className={`${styles.textfield}`}
                value={bankAccount}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^\d]/g, "");
                  setBankAccount(value);
                }}
                onMouseDown={handleBankClick}
                onBlur={handleBankBlur}
                ref={isBankFocused}
                readOnly
                disabled
              />
            </div>
          </div>

          <div className="blog-input-wrap mb-3">
            <div className="bankacc-btngroup d-flex justify-content-between flex-wrap">
              <button
                type="button"
                disabled={bankAccountLink === "false"}
                className={`btn mb-1 btn-primary-stroke`}
              >
                {`${customerTab?.directDebit.checkStatus} `}
                <span
                  className={`badge rounded-0 ${bankAccountLink === "false" ? "text-bg-danger" : "text-bg-success"}`}
                >
                  {bankAccountLink === "false" ? (
                    <>
                      <PiPlugsFill /> {customerTab?.directDebit.unlinked}
                    </>
                  ) : (
                    <>
                      <PiPlugsConnectedFill />
                      {` ${customerTab?.directDebit.linked}`}
                    </>
                  )}
                </span>
              </button>
              <button
                type="button"
                className="btn btn-primary-stroke mb-1"
                onClick={handleReLinkAccount}
              >
                {customerTab?.directDebit.relinkAcc}
              </button>
            </div>
          </div>

          {showRelinkAccount &&
            (accSoftwareIsConnctData?.disconnectedAt ||
            accSoftwareIsConnctData?.isConnected !== true ? (
              <div className="blog-input-wrap mb-3">
                <div className="inputtextfield">
                  <input
                    type="number"
                    name="accountCode"
                    className={`${styles.textfield} number-arrows-hidden`}
                    min={0}
                    placeholder={customerTab?.directDebit?.bankPlaceholder}
                    value={updateBankAccount}
                    onChange={handleBankDataChange}
                    onBlur={handleblurBankDataChange}
                  />
                  {bankError && (
                    <div className="text-danger small">{bankError}</div>
                  )}
                </div>
              </div>
            ) : (
              <>
                <div className="blog-input-wrap mb-3">
                  <div className="inputtextfield">
                    <select
                      className={`${styles.selectdropdown}`}
                      name="bankAccount"
                      value={selectedAccount}
                      onChange={handleSelectChange}
                    >
                      <option value="">
                        {customerTab?.directDebit.selectBankAcc}
                      </option>
                      {relinkBankOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                      <option value="manually-add-bank-account">
                        {customerTab?.directDebit.manuallyAddAcc}
                      </option>
                    </select>
                  </div>
                </div>
                {selectedAccount === "manually-add-bank-account" && (
                  <div className="blog-input-wrap mb-3">
                    <div className="inputtextfield">
                      <input
                        type="number"
                        name="accountCode"
                        className={`${styles.textfield} number-arrows-hidden`}
                        min={0}
                        placeholder={customerTab?.directDebit?.bankPlaceholder}
                        value={updateBankAccount}
                        onChange={handleBankDataChange}
                        onBlur={handleblurBankDataChange}
                      />
                      {bankError && (
                        <div className="text-danger small">{bankError}</div>
                      )}
                    </div>
                  </div>
                )}
              </>
            ))}

          <div className="blog-input-wrap">
            <div className={`${styles.labelTitle} border-bottom mb-3`}>
              <h5>
                {`${customerTab?.directDebit.externalBnkAcc} `}
                <button
                  type="button"
                  className={styles.syncBtn}
                  onClick={() => reloadUserBankData(true, true)}
                  title={tooltips.refreshBankAccounts}
                >
                  <FaSyncAlt className={spinning ? styles.spin : ""} />
                </button>
              </h5>
            </div>
            <div className="inputtextfield">
              <ul className={styles.bankAccountsAlert}>
                {!goCardlessBankData?.length && (
                  <li className="disabled border text-info">
                    <FaInfoCircle /> {customerTab?.directDebit.unabletoRefresh1}
                  </li>
                )}
                {accSoftwareId === undefined && (
                  <li className="disabled border text-info">
                    <FaInfoCircle /> {customerTab?.directDebit.unabletoRefresh2}
                  </li>
                )}
              </ul>
              <table id="bankAccountsTable" className="table table-condensed">
                <thead className="d-none">
                  <tr>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {goCardlessBankData &&
                    goCardlessBankData?.map((account) => {
                      let rowStyle = {};

                      if (account.isAccountMatched) {
                        rowStyle = { backgroundColor: "#d4edda" };
                      } else {
                        rowStyle = { backgroundColor: "#f8d7da" };
                      }

                      return (
                        <tr
                          key={account.id}
                          className="accsoft-row"
                          style={rowStyle}
                        >
                          <td>
                            <small>{account.bankName}</small>
                          </td>
                          <td>
                            <small>{account.maskedAccountNumber}</small>
                          </td>
                          <td className="text-end">
                            <span className="badge border text-dark rounded-0 border-success">
                              {GOCARDLESS}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  {accountingBankData &&
                    accountingBankData?.map((account) => {
                      let rowStyle = {};

                      if (account.matchConfidence === PARTIAL) {
                        rowStyle = { backgroundColor: "#fff3cd" };
                      } else if (account.matchConfidence === UNMATCHED) {
                        rowStyle = { backgroundColor: "#f8d7da" };
                      } else if (account.matchConfidence === COMPLETE) {
                        rowStyle = { backgroundColor: "#d4edda" };
                      }

                      return (
                        <tr
                          key={account.id}
                          className="accsoft-row"
                          style={rowStyle}
                        >
                          <td>
                            <small>{account.accountName}</small>
                          </td>
                          <td>
                            <small>{account.accountNumber}</small>
                          </td>
                          <td className="text-end">
                            {accSoftwareId === 1 && (
                              <span className="badge border text-dark rounded-0 border-success">
                                {createPricingPlan?.accSoftwareoptions.item1}
                              </span>
                            )}
                            {accSoftwareId === 2 && (
                              <span className="badge border text-dark rounded-0 border-success">
                                {accSofywareName?.myob}
                              </span>
                            )}
                            {accSoftwareId === 3 && (
                              <span className="badge border text-dark rounded-0 border-success">
                                {accSofywareName?.quickBooks}
                              </span>
                            )}
                            {accSoftwareId === 4 && (
                              <span className="badge border text-dark rounded-0 border-success">
                                {accSofywareName?.reckon}
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <PasswordSetModal
        isOpen={addPasswordModal}
        toggle={handleModalClose}
        handlePasswordEntered={handlePasswordEntered}
        setPasswordEntered={setCorrectPassword}
      />

      <UnavailableModal
        isOpen={directDebitModal}
        toggle={handleDirectDebitModal}
        modalData={modalData}
        status={status}
      />
      {tooltipsArray.map(({ id }) => (
        <ReactTooltip key={id} className="tooltipcustom" id={id} place="top" />
      ))}
    </>
  );
};
DirectDebit.propTypes = {
  accSoftwareIsConnctData: PropTypes.shape({
    disconnectedAt: PropTypes.string,
    isConnected: PropTypes.bool,
    accountingSoftwareType: PropTypes.string
  }),
  bankName: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.shape({
          BankAccountID: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
          ]),
          Description: PropTypes.string,
          AccountID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          Name: PropTypes.string,
          BankAccountNumber: PropTypes.string,
          accountUUID: PropTypes.string,
          accountName: PropTypes.string,
          accountNumber: PropTypes.string
        }),
        PropTypes.object
      ])
    ),
    PropTypes.shape({
      bankAccount: PropTypes.oneOfType([
        PropTypes.arrayOf(
          PropTypes.shape({
            BankAccountID: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.number
            ]),
            Description: PropTypes.string,
            AccountID: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.number
            ]),
            Name: PropTypes.string,
            BankAccountNumber: PropTypes.string,
            accountUUID: PropTypes.string,
            accountName: PropTypes.string,
            accountNumber: PropTypes.string
          })
        ),
        PropTypes.shape({
          accountUUID: PropTypes.string,
          accountName: PropTypes.string,
          accountNumber: PropTypes.string
        })
      ])
    })
  ]),
  accSoftwareId: PropTypes.number
};

export default DirectDebit;
